import { defaultStyles } from '@/helper/defaultStyles';
import { BlogPost } from '@/types/type';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import PostCard from './PostCard';

function PostsSection() {
  const { data } = useQuery({
    queryKey: ['BLOG_LIST'],
    queryFn: () =>
      axios
        .get('https://api.binnar.com.pl/blog/')
        .then((r) => r.data as BlogPost[]),
    staleTime: 10 * 60 * 1000,
  });

  return (
    <section
      className={`${defaultStyles.paddingBig} py-12 flex flex-col justify-center items-center`}
    >
      {data && data.length != 0 && (
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
          {data.map((item) => (
            <PostCard
              name={item.name}
              date={item.date}
              imageUrl={item.backgroundUrl}
              id={item.pk}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default PostsSection;
